(() => {
  const init = (root = document) => {
    root.querySelectorAll('.pbs-editorial[data-read-more]').forEach(section => {
      if (section.dataset.readMoreReady) return;
      section.dataset.readMoreReady = 'true';
      const mobile = matchMedia('(max-width: 749px)');
      const targets = [
        ...section.querySelectorAll('#description > .rte'),
        ...section.querySelectorAll('.pbs-editorial__specs'),
        ...section.querySelectorAll('.pbs-editorial__technical > .metafield-rich_text_field, .pbs-editorial__technical > .metafield-multi_line_text_field')
      ];
      targets.forEach((full, index) => {
        const description = full.matches('#description > .rte');
        const preview = full.cloneNode(false);
        preview.removeAttribute('id');
        preview.classList.add('pbs-read-more__preview');
        const control = document.createElement('button');
        control.type = 'button';
        control.className = 'pbs-read-more__button';
        full.id = section.closest('[id]').id + '-read-more-' + index;
        control.setAttribute('aria-controls', full.id);
        full.before(preview);
        full.after(control);
        let expanded = false;
        const buildPreview = () => {
          const range = document.createRange();
          range.selectNodeContents(full);
          let clipped = false;
          if (description) {
            const limit = mobile.matches ? 350 : 600;
            const walker = document.createTreeWalker(full, NodeFilter.SHOW_TEXT);
            const nodes = [];
            let node, text = '';
            while ((node = walker.nextNode())) { nodes.push(node); text += node.textContent; }
            if (text.trim().length > limit + 80) {
              const ends = [...text.matchAll(/[.!?](?:\s|$)/g)].map(m => m.index + 1);
              let total = 0;
              for (const n of nodes) {
                total += n.length;
                const block = n.parentElement.closest('p,li');
                if (block && n === nodes.filter(t => block.contains(t)).at(-1)) ends.push(total);
              }
              ends.sort((a, b) => a - b);
              const cut = ends.find(n => n >= limit) || text.length;
              if (cut < text.length - 40) {
                let position = 0;
                for (const n of nodes) {
                  if (position + n.length >= cut) {
                    range.setEnd(n, cut - position);
                    clipped = true;
                    break;
                  }
                  position += n.length;
                }
              }
            }
          } else {
            const limit = mobile.matches ? 8 : 12;
            const units = [...full.querySelectorAll('li, tr, p, br, dl > div')]
              .filter(el => el.tagName === 'BR' || (el.textContent.trim() && !el.querySelector('li, tr, p, br, dl > div')));
            if (full.matches('dl')) units.splice(0, units.length, ...full.children);
            const last = units.at(-1);
            if (last?.tagName === 'BR' && last.nextSibling?.textContent.trim()) units.push(full);
            if (units.length > limit) {
              range.setEndAfter(units[limit - 1]);
              clipped = true;
            }
          }
          preview.replaceChildren();
          if (clipped) {
            preview.append(range.cloneContents());
            preview.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
          }
          const render = () => {
            full.hidden = clipped && !expanded;
            preview.hidden = !clipped || expanded;
            control.hidden = !clipped;
            control.setAttribute('aria-expanded', String(expanded));
            control.textContent = expanded ? section.dataset.less : description ? section.dataset.descriptionMore : section.dataset.specsMore;
          };
          render();
          control.onclick = () => {
            expanded = !expanded;
            render();
            if (!expanded && control.getBoundingClientRect().top < 0) {
              control.scrollIntoView({block:'center'});
            }
          };
        };
        buildPreview();
        mobile.addEventListener('change', buildPreview);
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();